// SAHINKAYA — Password show/hide toggle.
// Pairs with snippets/input.liquid render param `show_password_toggle: true`
// and assets/password-toggle.css. The render emits a [data-password-toggle]
// button that this script attaches to via event delegation (no inline
// onclick, CSP-friendly). On each click the linked <input> flips between
// type=password and type=text, the aria-label/aria-pressed update, and the
// SVG inside the button swaps between the eye / eye-off variants stored in
// the data-icon-show / data-icon-hide attributes.
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-password-toggle]');
    if (!btn) return;
    e.preventDefault();

    const input = document.getElementById(btn.dataset.passwordToggle);
    if (!input) return;

    const willShow = input.type === 'password';
    input.type = willShow ? 'text' : 'password';

    btn.setAttribute('aria-pressed', String(willShow));
    btn.setAttribute('aria-label', willShow ? btn.dataset.hideLabel : btn.dataset.showLabel);
    btn.classList.toggle('is-showing', willShow);
    btn.innerHTML = willShow ? btn.dataset.iconHide : btn.dataset.iconShow;
  });
})();
